/* FastAPI puts a list of {msg,...} objects in `detail` for 422s. Rendering that
   straight into JSX crashes React, so always run API errors through this. */
export const formatApiError = (detail, fallback = "Something went wrong. Please try again.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : null))
      .filter(Boolean);
    return parts.length ? parts.join(" ") : fallback;
  }
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
};
